/* eslint-disable no-unused-vars */
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ACCOUNTING_CUSTOMERS_ACTION_TYPE = createNamedActions('accountingCustomers', {
  GET_CUSTOMERS: 'GET_CUSTOMERS',
});

export const getAccountingCustomersAction = catchAsyncActionError(params => async dispatch => {
  // const { data } = await accountingApi.getCustomers(params);
  // return dispatch({
  //   type: ACCOUNTING_CUSTOMERS_ACTION_TYPE.GET_CUSTOMERS,
  //   payload: data,
  // });
});
